import { DeleteAutorizacionMedica } from "./dacInfo.store";
import * as actions from "../../../actions/expedientes";
import { Preview } from "../../../../types/IAction";

export interface DacInfoDispatcher {
  deleteAutorizacionMedica: (
    idExpediente: number,
    codigoDocumento: string
  ) => Promise<Preview<DeleteAutorizacionMedica>>;
}

export const dacInfoDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => DacInfoDispatcher = dispatch => ({
  deleteAutorizacionMedica: (idExpediente: number, codigoDocumento: string) => {
    return dispatch(
      actions.deleteAutorizacionMedica(idExpediente, codigoDocumento)
    );
  }
});
